import { Routes } from '@angular/router';
import { anonymousGuard } from '@guards/anonymous.guard';
import { dashboardRoutes } from './pages/dashboard/dashboard.routes';

export const routes: Routes = [
  {
    canActivate: [anonymousGuard],
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
    path: '',
    title: 'Iniciar sesión | Mundo Hogar',
  },
  {
    canActivate: [anonymousGuard],
    loadComponent: () => import('./pages/enter-otp/enter-otp.page').then((m) => m.EnterOtpPage),
    path: 'enter-otp',
    title: 'Verificar Código OTP | Mundo Hogar',
  },
  {
    canActivate: [anonymousGuard],
    loadComponent: () => import('./pages/password-reset/password-reset.page').then((m) => m.PasswordResetPage),
    path: 'password-reset',
    title: 'Recuperar contraseña | Mundo Hogar',
  },
  {
    children: dashboardRoutes,
    path: 'dashboard',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
